import * as React from 'react';
import { ComponentType, useEffect } from 'react';
import { Button, notification } from '@duxton-web/ui';

import worker from './worker';
import Service from '@/lib/App';

const handleRefresh = () => {
  Service.cache?.clearServiceAndTableCache();
  navigator.serviceWorker.getRegistration().then((registration) => {
    const sw = registration?.waiting;
    if (sw) {
      sw.addEventListener('statechange', function handler() {
        if (sw.state === 'activated') {
          sw.removeEventListener('statechange', handler);
          window.location.reload();
        }
      });
      sw.postMessage({ type: 'SKIP_WAITING' });
    } else {
      window.location.reload();
    }
  });
};

const onServiceWorkerUpdate = (eventName: string) => {
  if (eventName === 'update-installed') {
    notification.info({
      duration: 0,
      message: 'New Version Update',
      description:
        'A new version has been downloaded. Please refresh the page to update.',
      placement: 'bottomLeft',
      btn: (
        <Button type="primary" size="small" onClick={handleRefresh}>
          Refresh
        </Button>
      ),
    });
  }
};

function WithUpdateWorker<P extends object>(
  WrappedComponent: ComponentType<P>,
): ComponentType<P> {
  function UpdateWorkerWrapper(props: P) {
    useEffect(() => {
      const cleanup = worker.register(onServiceWorkerUpdate);
      return cleanup;
    }, []);
    return <WrappedComponent {...props} />;
  }
  return UpdateWorkerWrapper;
}

export default WithUpdateWorker;
